<style>
.anketa-wrap {
    margin: 0 auto;
}

/* --- Анимация переходов --- */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
}

/* начальное состояние для появления */
.fade-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

/* конечное состояние для появления */
.fade-enter-to {
    opacity: 1;
    transform: translateY(0);
}

/* состояние для исчезновения */
.fade-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

@media (max-width: 450px) {
    /* твои адаптивные стили */
}

@import './assets/css/style.css';
</style>


<template>
    <div class="anketa-wrap">

        <template v-if="formType === 'pts-autozalog'">
            <transition name="fade" mode="out-in" appear>
                <component :is="currentComponent" :key="`pts-${currentComponent}`" :formType="formType"
                    :forwardPage="forwardPage" :backwardPage="backwardPage"
                    :previousPagePromise="previousPagePromise" />
            </transition>
        </template>


        <template v-else>
            <component :is="currentComponent" :formType="formType" :forwardPage="forwardPage"
                :backwardPage="backwardPage" :previousPagePromise="previousPagePromise" />
        </template>

    </div>
</template>

<script>
import * as Auth from '@/assets/js/auth.js'
import * as DataParams from '@/assets/js/data_params.js'
import * as GetParams from '@/assets/js/get_params.js'
import FormDefault from '@/components/FormDefault.vue';
import FormDefaultNew from '@/components/FormDefaultNew.vue';
import FormDefaultNewTwoConsent from '@/components/FormDefaultNewTwoConsent.vue';
import FormWeb from '@/components/FormWeb.vue';

import FormDefaultStepOne from '@/components/FormDefaultStepOne.vue';
import FormDefaultStepTwo from '@/components/FormDefaultStepTwo.vue';
import FormDefaultNewStepOne from '@/components/FormDefaultNewStepOne.vue';
import FormDefaultNewStepOneWithParams from '@/components/FormDefaultNewStepOneWithParams.vue';
import FormDefaultNewStepTwo from '@/components/FormDefaultNewStepTwo.vue';
import FormDefaultNewStepTwoWithParams from '@/components/FormDefaultNewStepTwoWithParams.vue';
import FormDefaultNewStepThree from '@/components/FormDefaultNewStepThree.vue';
import FormDefaultNewStepThreeWithParams from '@/components/FormDefaultNewStepThreeWithParams.vue';
import FormDefaultNewRegistration from '@/components/FormDefaultNewRegistration.vue';
import FormWithCalculator from '@/components/FormWithCalculator.vue';
import ZaymstarStart from '@/components/ZaymstarStart.vue';
import FormWithCalculatorStepTwo from '@/components/FormWithCalculatorStepTwo.vue';
import Card from '@/components/Card.vue';
import RedirectToCab from '@/components/RedirectToCab.vue';
import UnsubForm from '@/components/UnsubForm.vue';
import SubscriptionsList from '@/components/SubscriptionsList.vue';
import VamZaimStepTwo from '@/components/VamZaimStepTwo.vue';
import VamZaim from '@/components/VamZaim.vue';
import VamZaimStart from '@/components/VamZaimStart.vue';
import ZaymstarStartShort from '@/components/ZaymstarStartShort.vue';
import VamZaimStartShort from '@/components/VamZaimStartShort.vue';
import Zaymstar1Step from '@/components/Zaymstar1step.vue';

import SubscriptionsListZaymstar from '@/components/SubscriptionsListZaymstar.vue';
import UnsubFormZaymstar from '@/components/UnsubFormZaymstar.vue';

import FormPts from '@/components/FormPts.vue';
import FormBankruptcyZaymstar from '@/components/FormBankruptcyZaymstar.vue';
import Thanks from '@/components/Thanks.vue';
import Redirect from '@/components/Redirect.vue';
import RedirectToCard from '@/components/RedirectToCard.vue';
import RedirectToCardVamZaim from '@/components/RedirectToCardVamZaim.vue';
import Subscription from '@/components/Subscription.vue';
import SubscriptionVamZaim from '@/components/SubscriptionVamZaim.vue';
import PhoneConfirmation from './components/PhoneConfirmation.vue';
import BidShowcase from './components/BidShowcase.vue';
import BidShowcaseVamZaim from './components/BidShowcaseVamZaim.vue';
import BidShowcaseYazaym from './components/BidShowcaseYazaym.vue';
import BidShowcaseWbzaym from './components/BidShowcaseWbzaym.vue';
import BidShowcaseOzzaym from './components/BidShowcaseOzzaym.vue';
import BidShowcaseBzaym from './components/BidShowcaseBzaym.vue';
import BidShowcaseFixzaem from './components/BidShowcaseFixzaem.vue';
import BidShowcaseZaymna5 from './components/BidShowcaseZaymna5.vue';
import BidShowcaseDizaym from './components/BidShowcaseDizaym.vue';
import BidShowcaseZaymelo from './components/BidShowcaseZaymelo.vue';
import BidShowcase23zaym from './components/BidShowcase23zaym.vue';
import FormPTSAutozalog from './components/FormPTSAutozalog.vue';


var formType = DataParams.get('type', 'default');
var vuePages;

switch (formType) {
    case 'default':
        vuePages = [FormDefault, Subscription];
        break;
    case 'confirm':
        vuePages = [PhoneConfirmation];
        break;

    case 'default-free':
        vuePages = [FormDefault, Redirect];
        break;
    case 'default-free-new-confirmation':
        vuePages = [FormDefaultNewTwoConsent, PhoneConfirmation, Redirect];
        break;
    case 'default-free-new':
        vuePages = [FormDefaultNew, Redirect];
        break;
    case 'default-free-new-two-consent':
        vuePages = [FormDefaultNewTwoConsent, Redirect];
        break;
    case 'default-free-new-element':
        vuePages = [FormLongWeb, Thanks];
        break;
    case 'default-two-step':
        vuePages = [FormDefaultStepOne, FormDefaultStepTwo, Redirect];
        break;
    case 'default-new-three-step':
        vuePages = [FormDefaultNewStepOne, FormDefaultNewStepTwo, FormDefaultNewStepThree, RedirectToCab];
        break;
    case 'default-with-params-new-three-step':
        vuePages = [FormDefaultNewStepOneWithParams, FormDefaultNewStepTwoWithParams, FormDefaultNewStepThreeWithParams, RedirectToCab];
        break;
    case 'default-new-registration':
        vuePages = [FormDefaultNewRegistration, RedirectToCab];
        break;
    case 'pts':
        vuePages = [FormPts, Thanks];
        break;
    case 'bankruptcy':
        vuePages = [FormBankruptcyZaymstar, Thanks];
        break;
    case 'form-long-web':
        vuePages = [FormWeb, Thanks];
        break;
    case 'form-short-web':
        vuePages = [FormWeb, Thanks];
        break;
    case 'thanks':
        vuePages = [Thanks];
        break;
    case 'form-with-calculator':
        vuePages = [FormWithCalculator];
        break;
    case 'zaymstar-start':
        vuePages = [ZaymstarStart, RedirectToCard, Subscription];
        break;
    case 'form-with-calculator-step-two':
        vuePages = [FormWithCalculatorStepTwo, RedirectToCard, Subscription];
        break;
    case 'redirect-card':
        vuePages = [RedirectToCard, Card];
        break;
    case 'redirect-card-vamzaim':
        vuePages = [RedirectToCardVamZaim, Card];
        break;
    case 'redirect-to-cab':
        vuePages = [RedirectToCab];
        break;
    case 'card':
        vuePages = [Subscription];
        break;
    case 'cardvamzaim':
        vuePages = [SubscriptionVamZaim];
        break;
    case 'unsub':
        vuePages = [UnsubForm, SubscriptionsList];
        break;
    case 'unsubZaymstar':
        vuePages = [UnsubFormZaymstar, SubscriptionsListZaymstar];
        break;
    case 'vamzaim':
        vuePages = [VamZaim];
        break;
    case 'vamzaim-step-two':
        vuePages = [VamZaimStepTwo, RedirectToCard, SubscriptionVamZaim];
        break;
    case 'vamzaim-start':
        vuePages = [VamZaimStart, RedirectToCard, SubscriptionVamZaim];
        break;
    case 'subslist':
        vuePages = [SubscriptionsList];
        break;
    case 'subslistZaymstar':
        vuePages = [SubscriptionsListZaymstar];
        break;
    case 'bid-showcase':
        vuePages = [BidShowcase];
        break;
    case 'bid-showcase-vamzaim':
        vuePages = [BidShowcaseVamZaim];
        break;
    case 'bid-showcase-yazaym':
        vuePages = [BidShowcaseYazaym];
        break;
    case 'bid-showcase-wbzaym':
        vuePages = [BidShowcaseWbzaym];
        break;
    case 'bid-showcase-ozzaym':
        vuePages = [BidShowcaseOzzaym];
        break;
    case 'bid-showcase-bzaym':
        vuePages = [BidShowcaseBzaym];
        break;
    case 'bid-showcase-fixzaem':
        vuePages = [BidShowcaseFixzaem];
        break;
    case 'bid-showcase-zaymna5':
        vuePages = [BidShowcaseZaymna5];
        break;
    case 'bid-showcase-dizaym':
        vuePages = [BidShowcaseDizaym];
        break;
    case 'bid-showcase-zaymelo':
        vuePages = [BidShowcaseZaymelo];
        break;
    case 'bid-showcase-23zaym':
        vuePages = [BidShowcase23zaym];
        break;
    case 'zaymstar-1step':
        vuePages = [Zaymstar1Step, RedirectToCard, Subscription];
        break;
    case 'zaymstar-start-short':
        vuePages = [ZaymstarStartShort, RedirectToCard, Subscription];
        break;
    case 'vamzaim-start-short':
        vuePages = [VamZaimStartShort, RedirectToCard, Subscription];
        break;
    case 'pts-autozalog':
        vuePages = [FormPTSAutozalog, Thanks];
        break;
}
export default {
    components: { ...vuePages },

    data() {
        const key = `currentComponent_${location.pathname}`
        let savedStep = '0';

        try {
            const saved = JSON.parse(localStorage.getItem(key));
            if (saved && saved.timestamp) {
                const twelveHours = 12 * 60 * 60 * 1000;
                if ((Date.now() - saved.timestamp) < twelveHours) {
                    savedStep = saved.step;
                } else {
                    localStorage.removeItem(key); // устарел
                }
            }
        } catch (e) {
            localStorage.removeItem(key); // на случай повреждённых данных
        }

        return {
            formType: formType,
            currentComponent: savedStep,
            previousPagePromise: Promise.resolve()
        }
    },


    async created() {
        Auth.setTokenFromQuery();
        if (Auth.getToken()) {
            Auth.load("/client/profile")
                .then((data) => {
                    this.previousPagePromise = Promise.resolve(data);
                    this.currentComponent = '1';
                })
                .catch(() => { });
        }
    },

    methods: {
        forwardPage(promise) {
            if (typeof promise !== 'undefined') {
                this.previousPagePromise = promise;
            }

            this.currentComponent = (++this.currentComponent).toString();

            const key = `currentComponent_${location.pathname}`;
            localStorage.setItem(key, JSON.stringify({
                step: this.currentComponent,
                timestamp: Date.now()
            }));
        },

        backwardPage() {
            this.currentComponent = (--this.currentComponent).toString();

            const key = `currentComponent_${location.pathname}`;
            localStorage.setItem(key, JSON.stringify({
                step: this.currentComponent,
                timestamp: Date.now()
            }));
        }
    },
    mounted() {


    }
}
</script>
